const data = {
  underManagement: '1,000,000',
  underManagementSymbol: 'NXM',
  inReserve: '900,000',
  inReserveSymbol: 'NXM',
  protocols: [
    { nameLogo: 'Uniswap V2', logo: 'uniswapv2.png' },
    { nameLogo: 'Sushiswap', logo: 'sushiswap.jpg' },
    { nameLogo: 'Badger', logo: 'badger.png' },
    { nameLogo: 'Aave V2', logo: 'aavev2.svg' },
    { nameLogo: 'Compound V2', logo: 'compoundv2.png' },
    { nameLogo: 'MakerDAO', logo: 'makerdao.png' },
    { nameLogo: 'Curve', logo: 'curve.png' },
    { nameLogo: 'Coinbase', logo: 'coinbase.png' },
    { nameLogo: 'Binance', logo: 'binance.svg' },
    { nameLogo: 'RenVM', logo: 'ren.svg' },
  ],
}
export default data
